// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   Paper,
//   CircularProgress,
//   Snackbar,
//   Alert,
// } from "@mui/material";
// import { useAuth } from "../../App";
// import { hasPermission } from "../../utils/permissions";
// import Forbidden403 from "../../components/common/Forbidden403";
// import { API_URL } from "../../config";

// export default function GoogleCalendarSettingsPage() {
//   const { auth, fetchWithAuth } = useAuth();
//   // Permission check: superuser or has 'calendar-settings:list' permission
//   const hasManagePermission = hasPermission(auth?.user, "gcal_settings.manage");
//   if (!hasManagePermission) {
//     return <Forbidden403 />;
//   }
//   const [settings, setSettings] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [editMode, setEditMode] = useState(false);
//   const [form, setForm] = useState({
//     service_account_json: "",
//     calendar_id: "",
//     impersonate_email: "",
//   });
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   useEffect(() => {
//     fetchWithAuth(`${API_URL}/calendar-settings/`)
//       .then(async (res) => {
//         if (!res.ok) throw new Error("Failed to fetch settings");
//         const data = await res.json();
//         if (data && data.length > 0) {
//           setSettings(data[0]);
//           setForm({
//             service_account_json: data[0].service_account_json,
//             calendar_id: data[0].calendar_id,
//             impersonate_email: data[0].impersonate_email || "",
//           });
//         }
//         setLoading(false);
//       })
//       .catch((err) => {
//         setSnackbar({ open: true, message: err.message, severity: "error" });
//         setLoading(false);
//       });
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((f) => ({ ...f, [name]: value }));
//   };

//   const handleSave = async () => {
//     try {
//       let res;
//       if (settings) {
//         res = await fetchWithAuth(
//           `${API_URL}/calendar-settings/${settings.id}`,
//           {
//             method: "PUT",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify(form),
//           }
//         );
//       } else {
//         res = await fetchWithAuth(`${API_URL}/calendar-settings/`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(form),
//         });
//       }
//       if (!res.ok) throw new Error("Failed to save settings");
//       const data = await res.json();
//       setSettings(data);
//       setForm({
//         service_account_json: data.service_account_json,
//         calendar_id: data.calendar_id,
//         impersonate_email: data.impersonate_email || "",
//       });
//       setEditMode(false);
//       setSnackbar({
//         open: true,
//         message: "Settings saved",
//         severity: "success",
//       });
//     } catch (err) {
//       setSnackbar({ open: true, message: err.message, severity: "error" });
//     }
//   };

//   if (loading) {
//     return (
//       <Box
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         minHeight="40vh"
//       >
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <Paper sx={{ p: 4, maxWidth: 1000, mx: "auto" }}>
//       <Typography variant="h5" mb={2}>
//         Google Calendar Integration Settings
//       </Typography>
//       <Box component="form" noValidate autoComplete="off">
//         <TextField
//           label="Service Account JSON (or Path)"
//           name="service_account_json"
//           value={form.service_account_json}
//           onChange={handleChange}
//           fullWidth
//           margin="normal"
//           multiline
//           minRows={3}
//           disabled={!editMode}
//         />
//         <TextField
//           label="Calendar ID"
//           name="calendar_id"
//           value={form.calendar_id}
//           onChange={handleChange}
//           fullWidth
//           margin="normal"
//           disabled={!editMode}
//         />
//         <TextField
//           label="Impersonate Email (optional)"
//           name="impersonate_email"
//           value={form.impersonate_email}
//           onChange={handleChange}
//           fullWidth
//           margin="normal"
//           disabled={!editMode}
//         />
//         {editMode ? (
//           <Box mt={2} display="flex" gap={2}>
//             <Button variant="contained" color="primary" onClick={handleSave}>
//               Save
//             </Button>
//             <Button variant="outlined" onClick={() => setEditMode(false)}>
//               Cancel
//             </Button>
//           </Box>
//         ) : (
//           <Box mt={2}>
//             <Button variant="contained" onClick={() => setEditMode(true)}>
//               Edit
//             </Button>
//           </Box>
//         )}
//       </Box>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert
//           severity={snackbar.severity}
//           onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Paper>
//   );
// }


import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  CircularProgress,
  Snackbar,
  Alert,
  Container,
  Toolbar,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import AdminSidebar from "../../AdminSidebar";
import { useAuth } from "../../App";
import { hasPermission } from "../../utils/permissions";
import Forbidden403 from "../../components/common/Forbidden403";
import { API_URL } from "../../config";

function SectionEyebrow({ children, color }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
        color,
        fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: "10.5px",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        fontWeight: 500,
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 2,
          borderRadius: 2,
          bgcolor: "currentColor",
          flexShrink: 0,
        }}
      />
      {children}
    </Box>
  );
}

export default function GoogleCalendarSettingsPage() {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const accent = dark ? "#fb923c" : "#f97316";
  const pageBg = dark ? "#07080f" : "#ffffff";
  const panelBg = dark ? "#0d1220" : "#ffffff";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const { auth, fetchWithAuth } = useAuth();
  const hasManagePermission = hasPermission(auth?.user, "gcal_settings.manage");

  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({
    service_account_json: "",
    calendar_id: "",
    impersonate_email: "",
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  if (!hasManagePermission) {
    return (
      <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
        <AdminSidebar selected="Google Calendar Settings" />
        <Box
          sx={{
            flex: 1,
            p: 3,
            mt: 7,
            mb: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Forbidden403 />
        </Box>
      </Box>
    );
  }

  useEffect(() => {
    fetchWithAuth(`${API_URL}/calendar-settings/`)
      .then(async (res) => {
        if (!res.ok) throw new Error("Failed to fetch settings");
        const data = await res.json();
        if (data && data.length > 0) {
          setSettings(data[0]);
          setForm({
            service_account_json: data[0].service_account_json,
            calendar_id: data[0].calendar_id,
            impersonate_email: data[0].impersonate_email || "",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setSnackbar({ open: true, message: err.message, severity: "error" });
        setLoading(false);
      });
  }, [fetchWithAuth]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSave = async () => {
    try {
      let res;
      if (settings) {
        res = await fetchWithAuth(`${API_URL}/calendar-settings/${settings.id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });
      } else {
        res = await fetchWithAuth(`${API_URL}/calendar-settings/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });
      }
      if (!res.ok) throw new Error("Failed to save settings");
      const data = await res.json();
      setSettings(data);
      setForm({
        service_account_json: data.service_account_json,
        calendar_id: data.calendar_id,
        impersonate_email: data.impersonate_email || "",
      });
      setEditMode(false);
      setSnackbar({
        open: true,
        message: "Settings saved",
        severity: "success",
      });
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: "error" });
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
        <AdminSidebar selected="Google Calendar Settings" />
        <Box
          sx={{
            flex: 1,
            display: "grid",
            placeItems: "center",
          }}
        >
          <CircularProgress sx={{ color: accent }} />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
      <AdminSidebar selected="Google Calendar Settings" />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pl: { xs: 1.5, md: 3 },
          pr: { xs: 1.5, md: 3 },
          pt: 2,
          pb: 3,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Toolbar />

        <Container maxWidth="xl" disableGutters sx={{ mt: 1 }}>
          <Box
            sx={{
              mb: 3,
              overflow: "hidden",
              borderRadius: "28px",
              border: `1px solid ${border}`,
              background: dark
                ? `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(7,8,15,0.96) 45%, rgba(7,8,15,0.98) 100%)`
                : `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(255,255,255,0.98) 42%, rgba(248,248,251,0.98) 100%)`,
              boxShadow: dark
                ? "0 32px 80px rgba(0,0,0,0.30)"
                : "0 32px 80px rgba(15,15,26,0.08)",
            }}
          >
            <Box
              sx={{
                p: { xs: 3, sm: 4, md: 5 },
                display: "flex",
                alignItems: { xs: "flex-start", sm: "center" },
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 1.5,
              }}
            >
              <Box>
                <SectionEyebrow color={accent}>AjiraHQ · Google Calendar Settings</SectionEyebrow>
                <Typography
                  sx={{
                    mt: 2,
                    color: text,
                    fontWeight: 800,
                    fontSize: "clamp(30px, 4vw, 44px)",
                    lineHeight: 1.06,
                    letterSpacing: "-0.03em",
                    mb: 0.75,
                  }}
                >
                  Manage calendar integration settings.
                </Typography>
                <Typography
                  sx={{
                    color: mid,
                    fontSize: "15px",
                    lineHeight: 1.8,
                    maxWidth: 700,
                  }}
                >
                  Configure service account access, calendar ID, and impersonation
                  settings while keeping the current integration logic unchanged.
                </Typography>
              </Box>
            </Box>
          </Box>

          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              borderRadius: "22px",
              background: panelBg,
              border: `1px solid ${border}`,
              boxShadow: dark
                ? "0 20px 50px rgba(0,0,0,0.20)"
                : "0 12px 30px rgba(15,23,42,0.06)",
              maxWidth: 1000,
            }}
          >
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: "1.2rem",
                color: text,
                mb: 2,
                letterSpacing: "-0.02em",
              }}
            >
              Google Calendar Integration Settings
            </Typography>

            <Box component="form" noValidate autoComplete="off">
              <TextField
                label="Service Account JSON (or Path)"
                name="service_account_json"
                value={form.service_account_json}
                onChange={handleChange}
                fullWidth
                margin="normal"
                multiline
                minRows={3}
                disabled={!editMode}
              />

              <TextField
                label="Calendar ID"
                name="calendar_id"
                value={form.calendar_id}
                onChange={handleChange}
                fullWidth
                margin="normal"
                disabled={!editMode}
              />

              <TextField
                label="Impersonate Email (optional)"
                name="impersonate_email"
                value={form.impersonate_email}
                onChange={handleChange}
                fullWidth
                margin="normal"
                disabled={!editMode}
              />

              {editMode ? (
                <Box mt={2} display="flex" gap={2}>
                  <Button variant="contained" onClick={handleSave}>
                    Save
                  </Button>
                  <Button variant="outlined" onClick={() => setEditMode(false)}>
                    Cancel
                  </Button>
                </Box>
              ) : (
                <Box mt={2}>
                  <Button variant="contained" onClick={() => setEditMode(true)}>
                    Edit
                  </Button>
                </Box>
              )}
            </Box>
          </Paper>

          <Snackbar
            open={snackbar.open}
            autoHideDuration={4000}
            onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert
              severity={snackbar.severity}
              onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>
        </Container>
      </Box>
    </Box>
  );
}